// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  streamId: __t.u64().primaryKey().name("stream_id"),
  streamName: __t.string().name("stream_name"),
  value: __t.u64(),
  eventTime: __t.timestamp().name("event_time"),
  description: __t.string(),
});
